<template>
  <i :class="iconClass" />
</template>
<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'Icon',
  props: {
    iconClass: {
      type: String,
      required: true
    }
  }
})
</script>
